import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { LookupService } from 'src/app/Services/Common/lookup.service';
import { HrService } from 'src/app/services/hr/hr.service';

@Component({
  selector: 'app-salary-list-print',
  templateUrl: './salary-list-print.component.html',
  styleUrls: ['./salary-list-print.component.css']
})
export class SalaryListPrintComponent implements OnInit {

  OrganizationDetails: any;
  StudentMonthlyAttendanceList: any;
  StudentMonthlyDayList: any;
  CurrentStatusHeader: any;

  SalaryCalculationModel = {
    MonthID: 0,
    PaymentModeID: 0,
    EmployeeCategoryID: 0,
    PrimaryDepartmentID:0
   

  }
  DisplayModel = {
    ClassName: '',
    PackageName: '',
    TotalNetAmount:0,
  }

  SalaryStatementList: any;
  Integer: any;
  decimal: any;
  itemsPerPage = 10;
  pagedItems = [];

  constructor(private activatedRoute: ActivatedRoute, private payrollService: HrService,
    private spinnerService: Ng4LoadingSpinnerService, public globalHelper: GlobalHelper) {
    this.activatedRoute.queryParams.subscribe(params => {
      this.SalaryCalculationModel.EmployeeCategoryID = params['EmployeeCategoryID'];
      this.SalaryCalculationModel.MonthID = params['MonthID'];
      this.SalaryCalculationModel.PaymentModeID = params['PaymentModeID'];
      this.SalaryCalculationModel.PrimaryDepartmentID = params['PrimaryDepartmentID'];
      this.GetStaffSalaryPrint();
    });

  }
  GetStaffSalaryPrint() {
    this.spinnerService.show()
    this.payrollService.GetStaffSalaryPrint(JSON.stringify(this.SalaryCalculationModel)).subscribe((response) => {
      this.OrganizationDetails = response.BranchDetails;      
      this.spinnerService.hide()
       if (response.SalaryStatementList!=null) {
        this.SalaryStatementList = response.SalaryStatementList;
        
        var TotalNetAmount = 0;
        // for (var i = 0; i < this.SalaryStatementList.length; i++) {
        //   TotalNetAmount = TotalNetAmount + this.SalaryStatementList[i].NetSalary;
          
        // }
        // this.DisplayModel.TotalNetAmount = TotalNetAmount;
      
        var str = (this.globalHelper.Decimal(this.DisplayModel.TotalNetAmount)).toString().trim();       
        var substr = str.split('.');
        this.Integer = substr[0];
        this.decimal = (substr.length == 2 ? substr[1] : 0);
        this.spinnerService.hide()
        setTimeout(function () {
          window.print();
        }, 300);
      }


    });
  };


  search(itemlist) {

    for (var i = 0; i < itemlist.length; i++) {
      if (i % this.itemsPerPage === 0) {
        this.pagedItems[Math.floor(i / this.itemsPerPage)] = [itemlist[i]];
      } else {
        this.pagedItems[Math.floor(i / this.itemsPerPage)].push(itemlist[i]);
      }
    }

  }

  ngOnInit() {
  }

}
